var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "panel-body mt-4" },
    [
      _c("div", { staticClass: "panel-tag" }, [
        _vm._v("\n        Інструкції ІМК\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "instructions mt-4" }, [
        _c(
          "ul",
          { staticClass: "list-group" },
          _vm._l(_vm.items, function (item) {
            return _c("li", { key: item.id, staticClass: "list-group-item" }, [
              _c(
                "a",
                {
                  staticClass: "instruction",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.show_item(item)
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fal fa-code-merge width-2 fs-xl" }),
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.title) +
                      "\n                "
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("instruction_modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }